module.exports = __webpack_public_path__ + "img/vuelogo.99a1ee67.svg";